export default {
  init() {
    // JavaScript to be fired on all pages
    this.scrollHeader();
    this.reviewsSlider();
    this.labelClass();
    this.scroll();
    this.callModal();
    this.phoneMask();
    this.showMore();
    this.magnificPopup();
    this.serviceTab();
    this.prodCheck();
    this.dropMenu();
    this.scrollUp();
  },

  scrollHeader() {
    $(window).scroll(function () {
      let scroll = $(window).scrollTop();
      if (scroll >= 30) {
        $('.banner').addClass('scrolled');
      } else {
        $('.banner').removeClass('scrolled');
      }
    });
  },

  reviewsSlider() {
    let slider = $('.front-page__reviews-content');
    slider.addClass('owl-carousel')
      .owlCarousel({
        center: false,
        loop: true,
        margin: 20,
        nav: false,
        dots: true,
        items: 2,
        autoplay: false,
        autoplayTimeout: 10500,
        autoplayHoverPause: false,
        autoHeight: false,
        autoplaySpeed: 1000,
        navSpeed: 2000,
        mouseDrag: true,
        touchDrag: true,
        responsive: {
          0: {
            items: 1,
          },
          560: {
            items: 1,
          },
          768: {
            items: 2,
          },
        },
      })
  },

  labelClass() {
    $('.wpcf7-form-wrapper-checkbox label').addClass('checked');

    $('.wpcf7-form-wrapper-checkbox label').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('checked');
      if ($(this).hasClass('checked')) {
        $(this).find('input').prop('checked', true);
      } else {
        $(this).find('input').prop('checked', false);
      }
    });
  },

  scroll() {
    let $page = $('html, body');
    $('a[href*="#"]').click(function() {
      $page.animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 140,
      }, 600);
      return false;
    });
  },

  callModal() {
    /*
    $('.banner__main-contact-button, .front-page__catalog-tab-info-inner-button').on('click', function (e) {
      e.preventDefault();
      $('.modal__wrapper').fadeIn(250);
      $('#wpcf7-f155-o1').fadeIn(250);
      $('#wpcf7-f155-o2').fadeIn(250);
      $('#wpcf7-f155-o3').fadeIn(250);
    });

    $('.modal__wrapper, .modal__block-close-modal').on('click', (e) => {
      if ($(e.target).hasClass('modal__wrapper') || $(e.target).hasClass('modal__block-close-modal')) {
        $('.modal__wrapper').fadeOut(250);
        $('.modal__block > .wpcf7').fadeOut(250);
      }
    });
    */
  },

  phoneMask() {
    $('input[type="tel"]').mask('9 (999) 999-9999');
    //$('input[type="tel"]').mask('+7 (999) 999-9999');
  },

  showMore() {
    /*
    $('.front-page__reviews_item-footer-more').click(function () {
      $(this).parent().parent().find('.front-page__reviews_item-text p:nth-of-type(n+2)').toggleClass('visible');
      $(this).text($(this).text() == 'Читать полностью' ? 'Свернуть' : 'Читать полностью');
    });
    */
  },

  magnificPopup() {
    $('.repair-page__why-content-image img').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true,
        tCounter: '%curr% из %total%',
      },
      callbacks: {
        elementParse: function (qw) {
          qw.src = qw.el.attr('src');
        },
      },
    });

    $('.front-page__advantages_info-image img').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true,
        tCounter: '%curr% из %total%',
      },
      callbacks: {
        elementParse: function (qw) {
          qw.src = qw.el.attr('src');
        },
      },
    });
  },

  serviceTab() {
    let tabItem = '.product-page__system-content_item';
    let contentItem = '.product-page__service-main';

    //$(tabItem + ':first-of-type').addClass('item--active')
    //$(tabItem + ':not(:first-of-type)').removeClass('item--active')
    /* клик по любому табу */
    $(tabItem).click(function () {
      /* убираем активность с перового таба */
      $(tabItem).fadeOut(0);
      $('.product-page__system-title').fadeOut(0);
      $('.product-page__service-title').fadeIn(0);
      $('.product-page__service-back').fadeIn(0);
      /* делаем таб активным */
      $(this).toggleClass('item--active');
      /* первый блок в топку */
      $(contentItem).fadeOut(0);
      /* ищем блок с идентичным свойством data-name для отображения */
      $(contentItem + '[data-name="' + $(this).data('name') + '"]').fadeToggle(100);
      /* проверяем, если нет выбранных табов то выыводим вновь все и делаем первый таб активным */
      if ($('.item--active').length < 1) {
        $(tabItem).addClass('item--active');
      }
    });

    /* клик по первому табу */
    $(tabItem).click(function () {
      $(tabItem).removeClass('item--active');
      $(this).addClass('item--active');
    });
  },

  prodCheck() {
    let arrayServices = [];
    let strServices = '';
    $('.product-page__service-content_item-info-check').click(function () {
      let title = $(this).attr('id');
      if (!$(this).hasClass('checked')) {
        arrayServices.push(title);
        console.log(arrayServices);
        $(this).addClass('checked');
      }
      else {
        let index = arrayServices.indexOf(title);
        arrayServices.splice(index, 1);
        console.log(arrayServices);
        $(this).removeClass('checked');
      }
      arrayServices.forEach(function(item) {
        strServices += `${item} | `;
      });
      console.log(strServices);
      $('.hide-title').val(strServices);
      strServices = '';
    });
  },

  dropMenu() {
    /*if ($(window).width() < 768) {
      $('.front-page__catalog-content > .front-page__catalog-content-item > a').click(function(e) {
        e.preventDefault();
        let href = $(this).attr('href');
        if($(this).hasClass('active-sub-menu')){
          //$(this).siblings('.sub-menu').css('display','none');
          $(this).parent().parent().addClass('test');
          document.location.href = href;
        } else {
          $('.banner__nav-primary-list > .front-page__catalog-content-item > a').removeClass('active-sub-menu');
          //$('.banner__nav-primary-list > .menu-item-has-children > .sub-menu').css('display','none');
          $(this).addClass('active-sub-menu');
          //$(this).siblings('.sub-menu').css('display','flex');
        }
      })
    }*/

    $('#menu-vybor-kategorij').click('a',function(e) {
      console.log(1);
      //e.preventDefault();
      console.log(2);
      $(this).parent().parent().find('.category-page__nav').toggleClass('active-menu');

      let count = $(this).data('count');
      console.log(3);
      if(!count) {
        console.log(4);
        $(this).data('count', 1);
        e.preventDefault();
      }
    });

    if ($(window).width() < 768) {
      $('.banner__nav-primary-list li.menu-item a[href*="#contact"]').click(function () {
        $('.banner__nav-primary').removeClass('banner__nav-primary--active');
        $('.navi').removeClass('navi--active');
      });
    }

    /*
    if ($('.banner__nav-primary-list li.menu-item a#contact').click(function () {
      $('.banner__nav-primary').removeClass('navi--active');
    }));
    */
  },

  scrollUp() {
    $('.scrollup').click(function(){
      $('html, body').animate({ scrollTop: 0 }, 600);
      return false;
    });
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.navi').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('navi--active');
      $('.banner__nav-primary').toggleClass('banner__nav-primary--active');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js